import {
    AR,
    ZH,
    ZH_TW,
    CS,
    DA,
    NL,
    FI,
    FR,
    DE,
    HE,
    ID,
    IT,
    JA,
    KO,
    PL,
    PT,
    RU,
    ES,
    SV,
    TR,
} from './languages'

export const CORRECT = 'Correct! Click next to continue ...'
export const ENTER_NUMBER = 'Enter number'
export const FLOOR = 'FLOOR'
export const INCORRECT = 'Incorrect. Please try again ...'
export const LANDLINE = 'WORK PHONE'
export const LANGUAGE = 'LANGUAGE'
export const NEXT = 'Next'
export const PHONE = 'MOBILE PHONE'
export const PREVIOUS = 'Previous'
export const PROGRESS = 'Progress'
export const SELECT_FLOOR = 'Select a floor'
export const SELECT_LANGUAGE = 'Select a language'
export const SELECT_SUITE = 'Select a suite'
export const SUBMIT = 'SUBMIT'
export const SUITE = 'SUITE'
export const UPDATE_YOUR_PROFILE = 'Update your profile information.'
export const YOUR_NEW_PHONE_NUMBER = 'Your new phone number requires verification.'

//Dashboard
export const WELCOME = 'Welcome'
export const TODAY_DATE = "Today's Date"
export const NEXT_TRAINING = 'Your Next Training'
export const BUILDING_NAME = 'Building Name'

// Navigation menu
export const DASHBOARD = 'Dashboard'
export const SEARCH = 'Search'
export const DOCUMENTS = 'Documents'
export const NOTIFICATIONS = 'Notifications'
export const CALENDAR = 'Calendar'
export const TRAINING_PROGRAMS = 'Training Programs'
export const PROCEDURES = 'Procedures'
export const REPORTS = 'Training Status'
export const RESOURCES = 'Resources'
export const EVACUATION_ASSISTANCE = 'Evacuation Assistance'
export const FLOOR_WARDEN = 'Floor Warden'
export const FLOOR_PLANS = 'Floor Plans'
export const LIBRARY = 'Library'
export const PLAYLISTS = 'Playlists'
export const QUIZZES = 'Quizzes'
export const VIDEOS = 'Videos'
export const SUPPORT = 'Support'
export const WEATHER = 'Weather'
export const ADVISORIES = 'Advisories'
export const MAP = 'Map'
export const OCCUPANT_LIFE_SAFETY_TRAINING = 'Occupant Life Safety Training'
export const FLOOR_WARDEN_TRAINING = 'Floor Warden Training'
export const ADDITIONAL_RESOURCES = 'Resource Links'
export const ACKNOWLEDGMENT = 'Acknowledgments'
export const PROGRAM_REPORTS = 'Program Reports'
export const ADMIN = 'Administration'
export const CLIENTS = 'Clients'
export const BUILDING = 'Buildings'
export const PROPERTIES = 'Properties'
export const TENANTS = 'Tenants'

// Admin Manager
export const TENANT_ACKNOWLEDGMENT = 'Tenant Acknowledgments'

export const DICTIONARY = {
    [AR]: {
        [PROGRESS]: 'تقدم',
        [PREVIOUS]: 'سابق',
        [NEXT]: 'التالي',
        [CORRECT]: 'صحيح ، انقر فوق التالي للمتابعة',
        [INCORRECT]: 'غير صحيح ، الرجاء المحاولة مرة أخرى',
        [DASHBOARD]: 'لوحة القيادة',
        [SEARCH]: 'بحث',
        [DOCUMENTS]: 'مستندات',
        [NOTIFICATIONS]: 'إخطارات',
        [CALENDAR]: 'التقويم',
        [TRAINING_PROGRAMS]: 'برامج تدريبية',
        [PROCEDURES]: 'الإجراءات',
        [REPORTS]: 'تقارير',
        [EVACUATION_ASSISTANCE]: 'مساعدة الإجلاء',
        [SUPPORT]: 'مساعدة',
        [WEATHER]: 'الطقس',
        [ADVISORIES]: 'تحذيرات',
        [ADDITIONAL_RESOURCES]: 'موارد إضافية',
        [MAP]: 'خريطة',
        [RESOURCES]: 'مصادر',
        [OCCUPANT_LIFE_SAFETY_TRAINING]: 'السكان على سلامةالحياة تدريبات',
        [FLOOR_WARDEN_TRAINING]: 'الطابق مراقب تدريبات',
        [FLOOR_PLANS]: 'خطط المبنى',
        [FLOOR_WARDEN]: 'الطابق مراقب',
        [MAP]: 'خريطة',
        [WELCOME]: 'مرحبادو',
        [TODAY_DATE]: 'اريخ اليوم',
        [NEXT_TRAINING]: ' تدريبك القاد',
        [BUILDING_NAME]: ' اسم المبنى',
    },
    [ZH]: {
        [PROGRESS]: '进步',
        [PREVIOUS]: '上一页',
        [NEXT]: '下一个',
        [CORRECT]: '正确！点击下一步继续...',
        [INCORRECT]: '不正确，请重试。',
    },
    [ZH_TW]: {
        [PROGRESS]: '進步了',
        [PREVIOUS]: '上一個',
        [NEXT]: '下一個',
        [CORRECT]: '正確！按一下 "下一步" 繼續...',
        [INCORRECT]: '不正確，請再試一次...',
    },
    [CS]: {
        [PROGRESS]: 'Pokrok',
        [PREVIOUS]: 'Předchozí',
        [NEXT]: 'Další',
        [CORRECT]: 'Správně! Klikněte na tlačítko Další pro pokračování...',
        [INCORRECT]: 'Nesprávné. Zkuste to prosím znovu...',
    },
    [DA]: {
        [PROGRESS]: 'Fremskridt',
        [PREVIOUS]: 'Forrige',
        [NEXT]: 'Næste',
        [CORRECT]: 'Korrekt! Klik ved siden af for at fortsætte...',
        [INCORRECT]: 'Forkert, prøv igen...',
    },
    [NL]: {
        [PROGRESS]: 'Vooruitgang',
        [PREVIOUS]: 'Vorige',
        [NEXT]: 'Volgende',
        [CORRECT]: 'Corrigeer! Klik naast om verder te gaan...',
        [INCORRECT]: 'Onjuist. Probeer het opnieuw...',
    },
    [FI]: {
        [PROGRESS]: 'Edistystä',
        [PREVIOUS]: 'Edellinen',
        [NEXT]: 'Seuraava',
        [CORRECT]: 'Napsauta vieressä jatkaaksesi...',
        [INCORRECT]: 'Väärin. Yritä uudelleen.',
    },
    [FR]: {
        [DASHBOARD]: 'DashFr',
        'Sign In': 'Se connecter',
        'Sign Up': "S'inscrire",
        [PROGRESS]: 'Progrès',
        [PREVIOUS]: 'Précédent',
        [NEXT]: 'Prochain',
        [CORRECT]: '',
        [INCORRECT]: 'Incorrect. Veuillez réessayer...',
    },
    [DE]: {
        [PROGRESS]: 'Fortschritt',
        [PREVIOUS]: 'Vorhergehend',
        [NEXT]: 'Neben',
        [CORRECT]: 'Correct ! Cliquez sur Suivant pour continuer...',
        [INCORRECT]: 'Falsch. Bitte versuchen Sie es erneut...',
    },
    [HE]: {
        [PROGRESS]: 'התקדמות',
        [PREVIOUS]: 'קודם',
        [NEXT]: 'הבא בתור',
        [CORRECT]: 'לחץ על הבא כדי להמשיך',
        [INCORRECT]: 'שגוי. אנא נסה שוב',
    },
    [ID]: {
        [PROGRESS]: 'Kemajuan',
        [PREVIOUS]: 'Sebelumnya',
        [NEXT]: 'Berikutnya',
        [CORRECT]: 'Klik next untuk melanjutkan...',
        [INCORRECT]: 'Sila cuba lagi.',
    },
    [IT]: {
        [PROGRESS]: 'Progressi',
        [PREVIOUS]: 'Precedente',
        [NEXT]: 'Avanti',
        [CORRECT]: 'Fai clic su Avanti per continuare...',
        [INCORRECT]: 'Non corretto. Riprova.',
    },
    [JA]: {
        [PROGRESS]: '進捗だ',
        [PREVIOUS]: '[前へ]',
        [NEXT]: '次へ',
        [CORRECT]: '正しい! 続行するには [次へ] をクリックしてください...',
        [INCORRECT]: '間違っています。もう一度お試しください。',
    },
    [KO]: {
        [PROGRESS]: '진행 상황',
        [PREVIOUS]: '이전',
        [NEXT]: '다음',
        [CORRECT]: '맞습니다. 계속하려면 다음을 클릭하십시오...',
        [INCORRECT]: '올바르지 않습니다. 다시 시도하십시오.',
    },
    [PL]: {
        [PROGRESS]: 'Postęp',
        [PREVIOUS]: 'Poprzedni',
        [NEXT]: 'Następny',
        [CORRECT]: 'Kliknij obok, aby kontynuować...',
        [INCORRECT]: 'Proszę spróbować ponownie.',
    },
    [PT]: {
        [PROGRESS]: 'Progresso',
        [PREVIOUS]: 'Costas',
        [NEXT]: 'Próximo',
        [CORRECT]: 'Corrigir! Clique em Avançar para continuar...',
        [INCORRECT]: 'Incorreto. Tente novamente.',
    },
    [RU]: {
        [PROGRESS]: 'Прогресс',
        [PREVIOUS]: 'Предыдущие',
        [NEXT]: 'Дальше',
        [CORRECT]: 'Верно! Нажмите кнопку Далее, чтобы продолжить...',
        [INCORRECT]: 'Неверно. Повторите попытку...',
    },
    [ES]: {
        [DASHBOARD]: 'Tablero',
        [DOCUMENTS]: 'Documentos',
        [FLOOR_PLANS]: 'Planos de planta',
        [FLOOR_WARDEN]: 'Guardián de piso',
        [ADVISORIES]: 'Noticias locales',
        [MAP]: 'Mapa',
        [NOTIFICATIONS]: 'Notificaciones',
        [REPORTS]: 'Informes',
        [RESOURCES]: 'Recursos',
        'Sign In': 'Registrarse',
        'Sign Up': 'Regístrate',
        [TRAINING_PROGRAMS]: 'Programas de entrenamiento',
        [WEATHER]: 'Alertas meteorológicas',
        [WELCOME]: 'Bienvenido',
        [NEXT_TRAINING]: 'Tu próximo entrenamiento',
        [PROGRESS]: 'Progreso',
        [PREVIOUS]: 'Anterior',
        [NEXT]: 'Próximo',
        [CORRECT]: '¡Correcto! Haga clic en Siguiente para continuar...',
        [INCORRECT]: 'Incorrecto. Inténtelo de nuevo.',
    },
    [SV]: {
        [ADMIN]: 'Hantera',
        [PROGRESS]: 'Framsteg',
        [PREVIOUS]: 'Tillbaka',
        [NEXT]: 'Nästa',
        [CORRECT]: 'Korrigera! Klicka på nästa för att fortsätta...',
        [INCORRECT]: 'Fel, försök igen.',
    },
    [TR]: {
        [PROGRESS]: 'İlerleme',
        [PREVIOUS]: 'Geri dön',
        [NEXT]: 'Sonraki',
        [CORRECT]: 'Doğru! Devam etmek için yanındaki tıklayın...',
        [INCORRECT]: 'Yanlış. Lütfen tekrar deneyin.',
    },
    huston: {
        [FLOOR_WARDEN]: 'Fire Warden',
    },
}
